import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { IAccount, listAccounts, createAccount, updateAccount, pageAccounts, IRolePermission, listRoles, listMenus, listPermissions, createRole, updateRole } from '../../service/api/account';
import moment from 'moment';
import AccountList from './AccountList';
import RoleList from './RoleList';
import MenuList from './MenuList';
import PermissionList from './PermissionList';
import OperateLogList from './OperateLogList';
import WechatLogList from './WechatLogList';
import WechatNoticeLogList from './WechatNoticeLogList';
const { TabPane } = Tabs;
const AccountView = (props: any) => {
  const [currentTabKey, setCurrentTabKey] = useState<number>(1);
  const [accountVisible, setAccountVisible] = useState(false);
  const [roleVisible, setRoleVisible] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [permissionVisible, setPermissionVisible] = useState(false);
  const [optlogVisible, setOptlogVisible] = useState(false);
  const [wechatlogVisible, setWechatlogVisible] = useState(false);
  const [wechatNoticelogVisible, setWechatNoticelogVisible] = useState(false);

  const tabExtraContent = () => {
    switch (currentTabKey) {
      case 1:
        return <Button type="primary" style={{ marginRight: '20px' }} onClick={() => {
          setAccountVisible(true);
        }} icon={<PlusOutlined />}>
          新增账号
        </Button>
      case 2:
        return <Button type="primary" style={{ marginRight: '20px' }} onClick={() => {
          setRoleVisible(true);
        }} icon={<PlusOutlined />}>
          新增角色
        </Button>
      default:
        return <></>
    }
  }

  function onTabChange(key: any) {
    console.log(key);
    setCurrentTabKey(Number(key));
  }

  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={['账号管理']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Tabs defaultActiveKey="1" onChange={onTabChange} style={{ marginBottom: 32 }}
              tabBarExtraContent={tabExtraContent()}>
              <TabPane tab="账号管理" key="1">
                <AccountList
                  visible={accountVisible}
                  setVisible={setAccountVisible}
                />
              </TabPane>
              <TabPane tab="角色管理" key="2">
                <RoleList
                  visible={roleVisible}
                  setVisible={setRoleVisible}
                />
              </TabPane>
              <TabPane tab="菜单管理" key="3">
                <MenuList
                  visible={menuVisible}
                  setVisible={setMenuVisible}
                />
              </TabPane>
              <TabPane tab="权限管理" key="4">
                <PermissionList
                  visible={permissionVisible}
                  setVisible={setPermissionVisible}
                />
              </TabPane>
              <TabPane tab="操作日志" key="5">
                <OperateLogList
                  visible={optlogVisible}
                  setVisible={setOptlogVisible}
                />
              </TabPane>
              <TabPane tab="微信操作日志" key="6">
                <WechatLogList
                  visible={wechatlogVisible}
                  setVisible={setWechatlogVisible}
                />
              </TabPane>
              <TabPane tab="微信通知日志" key="7">
                <WechatNoticeLogList
                  visible={wechatNoticelogVisible}
                  setVisible={setWechatNoticelogVisible}
                />
              </TabPane>
            </Tabs>
          </div>
        </Col>
      </Row>


    </div>
  );
};

export default AccountView;
